import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LinkedinIcon, MailIcon, ArrowRightIcon } from 'lucide-react';
import { Logo } from '../ui/Logo';
export const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const goTo = (path: string) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <footer className="bg-white text-black py-16 border-t border-gray-100 relative overflow-hidden" data-id="element-502">
      {/* Background pattern elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-purple-50 rounded-full opacity-40 -mr-32 -mt-32" data-id="element-503"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-purple-50 rounded-full opacity-30 -ml-40 -mb-40" data-id="element-504"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-505">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10" data-id="element-506">
          {/* Brand column */}
          <div className="md:col-span-5" data-id="element-507">
            <div className="mb-6" data-id="element-508">
              <Logo data-id="element-509" />
            </div>
            <p className="max-w-md mb-6 text-text-secondary text-base leading-relaxed" data-id="element-510">
              We embed senior AI operators in your team to ship agents, automate
              workflows, and lead your AI strategy — without the full-time hire.
              Start within 48 hours.
            </p>
            <button onClick={openCalendly} className="inline-flex items-center gap-2 text-primary hover:text-primary-dark transition-colors text-base font-semibold group" aria-label="Book a consult" data-id="element-511">
              Book a consult
              <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-512" />
            </button>
            {/* Social */}
            <div className="flex space-x-3 mt-8" data-id="element-513">
              <a href="https://www.linkedin.com/company/zero-to-ten" target="_blank" rel="noopener noreferrer" className="p-3 bg-purple-50 rounded-full hover:bg-purple-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary" aria-label="Visit our LinkedIn page" data-id="element-514">
                <LinkedinIcon className="w-5 h-5 text-primary" data-id="element-515" />
              </a>
              <a href="mailto:hello@zerototenadvisory.com" className="p-3 bg-purple-50 rounded-full hover:bg-purple-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary" aria-label="Email us" data-id="element-516">
                <MailIcon className="w-5 h-5 text-primary" data-id="element-517" />
              </a>
            </div>
          </div>

          {/* Services column */}
          <div className="md:col-span-3" data-id="element-518">
            <h4 className="text-sm font-semibold mb-5 text-black uppercase tracking-wider" data-id="element-519">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-520">
              <li data-id="element-521">
                <button onClick={() => goTo('/fractional-head-of-ai')} className="text-text-secondary hover:text-primary transition-colors text-base py-1 focus:outline-none focus:text-primary text-left" data-id="element-522">
                  Fractional Head of AI
                </button>
              </li>
              <li data-id="element-523">
                <button onClick={() => goTo('/fractional-pm')} className="text-text-secondary hover:text-primary transition-colors text-base py-1 focus:outline-none focus:text-primary text-left" data-id="element-524">
                  Fractional Product Management
                </button>
              </li>
              <li data-id="element-525">
                <button onClick={openCalendly} className="text-text-secondary hover:text-primary transition-colors text-base py-1 focus:outline-none focus:text-primary text-left" data-id="element-526">
                  AI Agents & Automation
                </button>
              </li>
              <li data-id="element-527">
                <button onClick={openCalendly} className="text-text-secondary hover:text-primary transition-colors text-base py-1 focus:outline-none focus:text-primary text-left" data-id="element-528">
                  AI Strategy & Discovery
                </button>
              </li>
            </ul>
          </div>

          {/* Company column */}
          <div className="md:col-span-2" data-id="element-529">
            <h4 className="text-sm font-semibold mb-5 text-black uppercase tracking-wider" data-id="element-530">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-531">
              <li data-id="element-532">
                <button onClick={() => goTo('/')} className="text-text-secondary hover:text-primary transition-colors text-base py-1 focus:outline-none focus:text-primary text-left" data-id="element-533">
                  Home
                </button>
              </li>
              <li data-id="element-534">
                <button onClick={openCalendly} className="text-text-secondary hover:text-primary transition-colors text-base py-1 focus:outline-none focus:text-primary text-left" data-id="element-535">
                  Book a consult
                </button>
              </li>
              <li data-id="element-536">
                <a href="https://www.linkedin.com/company/zero-to-ten" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors text-base py-1 focus:outline-none focus:text-primary" data-id="element-537">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

          {/* Contact column */}
          <div className="md:col-span-2" data-id="element-538">
            <h4 className="text-sm font-semibold mb-5 text-black uppercase tracking-wider" data-id="element-539">
              Contact
            </h4>
            <ul className="space-y-3" data-id="element-540">
              <li data-id="element-541">
                <a href="mailto:hello@zerototenadvisory.com" className="text-text-secondary hover:text-primary transition-colors text-base break-all focus:outline-none focus:text-primary" aria-label="Email us" data-id="element-542">
                  hello@zerototenadvisory.com
                </a>
              </li>
              <li className="text-text-secondary text-sm leading-relaxed pt-2" data-id="element-543">
                Response within 24 hours
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 mt-14 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-544">
          <p className="text-text-secondary text-sm" data-id="element-545">
            © <span id="year" data-id="element-546">{currentYear}</span> Zero to Ten. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-547">
            <a href="#" className="text-text-secondary hover:text-black transition-colors text-sm focus:outline-none focus:text-primary" aria-label="View terms of service" data-id="element-548">
              Terms
            </a>
            <a href="#" className="text-text-secondary hover:text-black transition-colors text-sm focus:outline-none focus:text-primary" aria-label="View privacy policy" data-id="element-549">
              Privacy
            </a>
            <a href="#" className="text-text-secondary hover:text-black transition-colors text-sm focus:outline-none focus:text-primary" aria-label="View cookie policy" data-id="element-550">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>;
};